import { Button } from 'react-bootstrap';

import styles from './Cipa.module.css';

const Cipa = props => {
  return (
    <div className={styles.cards_container}>
      <div className={styles.card_container}>
        <div className={styles.card_header}>
          <img className={styles.card_img_header} src="../../assets/img/fesaude-logo2.png" alt="Logo FeSaúde" />
        </div>
        <img className={`${props.buttonCipaDisabled ? styles.card_apuracao : styles.card_photo}`} src={props.foto} alt={props.nome} />
        <div className={styles.card_body}>
          <div className={styles.card_container_nome}>
            <p className={styles.card_nome}>{props.nome}</p>
          </div>
          <p className={styles.card_lotacao}>{props.lotacao}</p>
          <p>{props.funcao}</p>
          {!props.buttonCipaDisabled && (
            <Button
              onClick={props.selecionarCipa}
              value={props.nome}
              disabled={props.buttonCipaDisabled}
              variant="flat"
              className={styles.save_btn}
            >
              Selecionar
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Cipa;
